import { observer } from "mobx-react";
import React, { useEffect, useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";
import GlobelStore from "../../../Store/GlobelStore";
import { clientStatus } from "../../../Constants/Constants";

const LeadsChart = observer(() => {
  const [seriesData, setSeriesData] = useState([
    {
      label: "LEAD",
      value: 0,
    },
    {
      label: "INITIAL_REFERAL_MADE_TO_THE_COUNTY",
      value: 0,
    },
    {
      label: "NURSE_ASSESSMENT_SCHEDULE",
      value: 0,
    },
    {
      label: "NURSE_ASSESSMENT_DONE",
      value: 0,
    },
    {
      label: "SUPPORT_PLANNER_REFERAL_MADE",
      value: 0,
    },
    {
      label: "SUPPORT_PLANNER_VISIT",
      value: 0,
    },
    {
      label: "POS_RECEIVED",
      value: 0,
    },
    {
      label: "PENDING_MDH_DECISION",
      value: 0,
    },
  ]);

  const colors = [
    "#008FFB",
    "#00E396",
    "#FEB019",
    "#FF4560",
    "#775DD0",
    "#3F51B5",
    "#546E7A",
    "#D4526E",
    "#8D5B4C",
  ];

  const series = [
    {
      data: seriesData?.map((status) => status?.value) || [0],
    },
  ];
  const total = seriesData.reduce(
    (sum, status) => sum + (status?.value || 0),
    0
  );

  const options = useMemo(() => {
    return {
      chart: {
        height: 350,
        type: "bar",
      },
      colors: colors,
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "45%",
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      xaxis: {
        categories: seriesData?.map((status) => {
          return (
            clientStatus.find((item) => item.value === status?.label)?.label ||
            status?.label ||
            "Unknown"
          );
        }),
        labels: {
          style: {
            colors: colors,
            fontSize: "12px",
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (val, { dataPointIndex }) {
            const label =
              clientStatus.find(
                (item) => item.value === seriesData[dataPointIndex]?.label
              )?.label || "Unknown";
            return `${label}: ${val}`;
          },
        },
      },
    };
  });

  useEffect(() => {
    const leadsData = GlobelStore?.dashboardAllData?.leadsData;
    if (leadsData) {
      setSeriesData(leadsData || []);
    }
  }, [GlobelStore?.dashboardAllData]);

  return (
    <div>
      <div className="EmployeeChartMainContainerMini">
        <div className="titleContainer">
          <div className="title">Leads</div>
          <div className="total">Total: {total}</div>
        </div>
        <div className="detailContainerLeadsChart">
          <div id="chart">
            <ReactApexChart
              options={options}
              series={series}
              type="bar"
              height={350}
            />
          </div>
        </div>
      </div>
    </div>
  );
});

export default React.memo(LeadsChart);
